import React from 'react';
import * as s from '../../../../../ressources/StyleGlobal/StyleGlobal';
import FormulaireAxe from '../FormulaireAxe/FormulaireAxe';
import styles from '../FormulaireGraphe.module.scss';
import SelectField from './SelectField';

const AxisFormField = ({
  axisKey,
  axisName,
  axisConfig,
  axisType,
  gererConfigAxe,
  gererEtatDeCibleName,
  disabled = false,
}) => {
  const typeOptions = [
    { value: 'date', label: 'Date' },
    { value: 'linear', label: 'Lineaire' },
    { value: 'log', label: 'Logarithmique' },
  ];

  return (
    <div className={[s.col_12].join(' ')}>
      <FormulaireAxe
        gererConfigAxe={gererConfigAxe}
        axisKey={axisKey}
        axisName={axisName}
        preConfigAxe={{
          ...axisConfig,
          type: axisType,
        }}
        disabled={disabled}
      >
        <SelectField
          label={`${axisKey}_type`}
          name={`${axisKey}_type`}
          value={axisType}
          onChange={gererEtatDeCibleName}
          options={typeOptions}
          disabled={disabled}
          customClass={styles.stile}
        />
      </FormulaireAxe>
    </div>
  );
};

export default AxisFormField;
